import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/jetlend_react_lib/packages/jetlend-web-ui/src/ui/inputs/Button/Button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/jetlend_react_lib/packages/jetlend-web-ui/src/ui/TooltipIcon/Tooltip.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/ApplySection/ApplySection.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/BlogBody/BlogBody.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ExpandableItem/ExpandableItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SociaButtonsList/SocialButtonsList.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/WpPostContent/WpPostContent.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/WpPostNavigation/WpPostNavigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/WpPostNavigation/WpPostNavigationMobile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/features/borrowers/BecomeBorrowerForm/BecomeBorrowerForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/features/borrowers/BorrowersLeadForm/BorrowersLeadForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/features/investors/BecomeInvestorForm/BecomeInvestorForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/features/investors/InvestorsLeadForm/InvestorsLeadForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/features/news/NewsPostRecommendationsSection/NewsPostRecommendationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/features/partners/BecomePartnerForm/BecomePartnerForm.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/icons/app-store-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/google-play-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/wp-post/blockquote.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/wp-post/data-role.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/yandex-icon.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/ui/Section/Section.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/ui/SectionPart/SectionPart.tsx");
